import { useEffect, useState } from 'react';

import type { Locale } from '../i18n/locales';
import { sanityClient } from '../sanity/client';
import { articleBySlugQuery, type ArticleDetail } from '../sanity/queries';

export function useArticle(slug: string | undefined, locale: Locale) {
  const [article, setArticle] = useState<ArticleDetail | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!slug) {
      setLoading(false);
      return;
    }

    let cancelled = false;

    setLoading(true);
    setError(null);

    sanityClient
      .fetch<ArticleDetail | null>(articleBySlugQuery, { slug, lang: locale })
      .then((data) => {
        if (!cancelled) setArticle(data);
      })
      .catch((err) => {
        if (!cancelled) setError(err instanceof Error ? err : new Error(String(err)));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [slug, locale]);

  return { article, loading, error };
}
